




































































import ClientOnly from 'vue-client-only';
import { v4 as uuidv4 } from 'uuid';
import { defineComponent } from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { evidenceView } from '~/helpers/trackings/24orepro/components';
import Modal from '../Modal.vue';
import { PropType } from 'vue';
import { EvidencesType } from '~/types/solepro/PageBuilder';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Autoplay, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import { useContext } from '@nuxtjs/composition-api';

SwiperCore.use([Pagination, Autoplay])


export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<EvidencesType>,
            required: true
        }
    },
    components: {
        PageBuilderComponent,
        SwiperSlide,
        Swiper,
        Modal,
        ClientOnly
    },
    data() {
        return {
            modalContent: null,
            buttonRef: null,
            uniqueId: uuidv4()
        };
    },
    mounted() {
        this.$nextTick(() => {
            const elements = document.querySelectorAll(`[id^="button-evidence-${this.uniqueId}"]`);
            this.buttonRef = elements;
        });
    },
    setup(props) {
        const { app } = useContext()
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const autoplaySpeed = content.autoplay == "true" ? parseInt(content.autoplaySpeed) : 0;

        const navigation = content.showArrows == "true" ? {
            prevEl: '.section-testimonials .nav-left',
            nextEl: '.section-testimonials .nav-right'
        } : false ;

        const pagination = content.showDots == "true" ? { 
            el: ".section-testimonials .pagination",
            type: 'progressbar',
            progressbarFillClass: 'bg-black w-full block h-full'
        } : false;

        const swiperProps = {
            navigation,
            pagination,
            slidesPerView: "auto",
            spaceBetween: 12,
            autoplay: content.autoplay == "true" ? JSON.stringify({
                delay: autoplaySpeed,
                disableOnInteraction: false
            }) : false,
            crossFade: content.fade == "true",
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        }

       

        return {
            content,
            swiperProps,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    methods: {
        getBgImage(jsonString) {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            const $th = this as any;
            return images.desktop_image.replace($th.IMAGE_STATIC_REPLACEMENT, $th.IMAGE_CDN_REPLACEMENT)
        },
        initEvidence(slide) {
            evidenceView(slide);
            this.modalContent = slide;
        },
        resetEvidence() {
            this.modalContent = null;
        },
        isBackgroundImage(slide) {
            return slide.bannerDatas.backgroundType == "image";
        },
        isVideoImage(slide) {
            return slide.bannerDatas.backgroundType == "video";
        }
    }
})
